import { defineMessages } from 'react-intl'

export const jobsMainMessages = defineMessages({
  homes: {
    id: 'jobsMain.homes',
    description:
      'Title for switch which will show jobs with homes of current domain',
    defaultMessage: 'Homes',
  },
  pending: {
    id: 'jobsMain.pending',
    description:
      'Title for switch which will show pending jobs of current domain',
    defaultMessage: 'Pending Jobs',
  },
  addBtn: {
    id: 'jobsMain.addBtn',
    description: "Button title to open job's 'Add' menu (eg Add Home)",
    defaultMessage: 'Add',
  },
  newGroup: {
    id: 'jobsMain.newGroup',
    description: 'Job menu button to create new Group/Domain',
    defaultMessage: 'New Group',
  },
  renameGroup: {
    id: 'jobsMain.renameGroup',
    description: 'Job menu button to rename Group/Domain',
    defaultMessage: 'Rename Group',
  },
  exportGroup: {
    id: 'jobsMain.exportGroup',
    description: 'Job menu button to export Group/Domain',
    defaultMessage: 'Export Job Details as CSV',
  },
  exportDomain: {
    id: 'jobsMain.exportDomain',
    description: 'Domain menu button to export Group/Domain',
    defaultMessage: 'Export Job Details as CSV',
  },
  deleteGroup: {
    id: 'jobsMain.deleteGroup',
    description: 'Job menu button to delete Group/Domain',
    defaultMessage: 'Delete Group',
  },
  newHome: {
    id: 'jobsMain.newHome',
    description: 'Job menu button to add Home',
    defaultMessage: 'New Home',
  },
  searchHomes: {
    id: 'jobsMain.searchHomes',
    description: 'Placeholder text for search among Jobs with Homes',
    defaultMessage: 'Search Homes',
  },
  searchJobs: {
    id: 'jobsMain.searchJobs',
    description: 'Placeholder text for search among Pending Jobs',
    defaultMessage: 'Search Jobs',
  },
  noHomesFound: {
    id: 'jobsMain.noHomesFound',
    description:
      'Text to inform user that his search for Homes gave no results',
    defaultMessage: 'No homes found',
  },
  noJobsFound: {
    id: 'jobsMain.noJobsFound',
    description:
      'Text to inform user that his search for (pending) Jobs gave no results',
    defaultMessage: 'No jobs found',
  },
})
